/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { BaseDataSource } from "./BaseDataSource";
import { Base, typeCast, Array_$type, Number_$type, fromEnum, markType } from "./type";
import { RearrangedListView } from "./RearrangedListView";
import { DataSourcePropertiesComparer } from "./DataSourcePropertiesComparer";
import { List$1 } from "./List$1";
import { DataSourceExecutionContext } from "./DataSourceExecutionContext";
import { DataSourceLocalDataProvider } from "./DataSourceLocalDataProvider";
import { DataSourceSpecialRow } from "./DataSourceSpecialRow";
import { ISupportsDataChangeNotifications_$type } from "./ISupportsDataChangeNotifications";
import { TransactionType, TransactionType_$type } from "./TransactionType";
import { ISupportsExpansionChangeNotifications_$type } from "./ISupportsExpansionChangeNotifications";
/**
 * @hidden
 */
var LocalDataSource = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(LocalDataSource, _super);
    function LocalDataSource() {
        var _this = _super.call(this) || this;
        _this.cv = null;
        _this.cu = null;
        _this.dv = null;
        _this.c0 = null;
        _this.c4 = null;
        _this.c6 = null;
        _this.c2 = null;
        _this.dg = new List$1(Array_$type, 0);
        _this.c7 = false;
        _this.ct = null;
        _this.dp = -1;
        _this.dh = -1;
        _this.dr = -1;
        _this.dj = -1;
        _this.ds = -1;
        _this.dk = -1;
        _this.dq = -1;
        _this.di = -1;
        _this.du = -1;
        _this.dt = -1;
        _this.dm = -1;
        _this.dl = -1;
        _this.dn = -1;
        _this.executionContext = new DataSourceExecutionContext();
        _this.u.l = false;
        return _this;
    }
    LocalDataSource.prototype.get_actualBaseDataProvider = function () {
        return this.actualDataProvider;
    };
    Object.defineProperty(LocalDataSource.prototype, "actualBaseDataProvider", {
        get: function () {
            return this.get_actualBaseDataProvider();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LocalDataSource.prototype, "dataProvider", {
        get: function () {
            return this.cv;
        },
        set: function (a) {
            var b = this.cv;
            this.cv = a;
            if (b != this.cv) {
                this.onPropertyUpdated("DataProvider", b, this.cv);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LocalDataSource.prototype, "actualDataProvider", {
        get: function () {
            if (this.cu == null) {
                this.actualDataProvider = this.resolveDataProvider();
            }
            return this.cu;
        },
        set: function (a) {
            var b = this.cu;
            this.cu = a;
            if (b != this.cu) {
                this.onPropertyUpdated("ActualDataProvider", b, this.cu);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LocalDataSource.prototype, "dataSource", {
        get: function () {
            return this.dv;
        },
        set: function (a) {
            var b = this.dv;
            this.dv = a;
            if (b != this.dv) {
                this.onPropertyUpdated("ItemsSource", b, this.dv);
            }
        },
        enumerable: true,
        configurable: true
    });
    LocalDataSource.prototype.canInitialize = function () {
        var a = _super.prototype.canInitialize.call(this);
        if (!a) {
            return false;
        }
        return this.dataSource != null;
    };
    Object.defineProperty(LocalDataSource.prototype, "c1", {
        get: function () {
            return this.c0;
        },
        set: function (a) {
            this.c0 = a;
            this.actualDataProvider = this.resolveDataProvider();
        },
        enumerable: true,
        configurable: true
    });
    LocalDataSource.prototype.resolveDataProvider = function () {
        var provider_ = new DataSourceLocalDataProvider();
        provider_.executionContext = new DataSourceExecutionContext();
        return provider_;
    };
    LocalDataSource.prototype.propertyUpdatedOverride = function (a, b, c) {
        _super.prototype.propertyUpdatedOverride.call(this, a, b, c);
        switch (a) {
            case "DataProvider":
                this.actualDataProvider = this.dataProvider;
                break;
            case "ActualDataProvider":
                if (this.actualDataProvider != null) {
                    this.actualDataProvider.dataSource = this.dataSource;
                    this.actualSchema = this.actualDataProvider.actualSchema;
                    this.actualCount = this.resolveFullCount(this.actualDataProvider.actualCount);
                }
                this.queueAutoRefresh();
                break;
            case "ItemsSource":
                if (this.actualDataProvider != null) {
                    this.actualDataProvider.dataSource = this.dataSource;
                    this.actualSchema = this.actualDataProvider.actualSchema;
                    this.actualCount = this.resolveFullCount(this.actualDataProvider.actualCount);
                }
                this.queueAutoRefresh();
                break;
        }
    };
    LocalDataSource.prototype.getItemAtIndex = function (a) {
        if (this.c4 != null && this.c4.a6 != null) {
            return this.c4.a6.item(a);
        }
        else {
            return this.actualDataProvider.getItemAtIndex(a);
        }
    };
    LocalDataSource.prototype.getItemFromKey = function (a) {
        var b = this.actualPrimaryKey;
        if (b == null || b.length < 1 || this.actualBaseDataProvider == null) {
            return a[0];
        }
        var c = this.c3();
        var d;
        if (this.c4 != null) {
            var e = this.c4.a6.count;
            for (var f = 0; f < e; f++) {
                d = this.c4.a6.item(f);
                if (typeCast(DataSourceSpecialRow.$, d) !== null) {
                    var g = d;
                    if (g.rowType == 1 && !this.isSectionContentVisible && this.isSectionHeaderNormalRow) {
                        if (c.i(d, a) == 0) {
                            return d;
                        }
                    }
                }
                else if (c.i(d, a) == 0) {
                    return d;
                }
            }
            return null;
        }
        if (this.actualDataProvider != null && this.actualDataProvider.isKeyIndexLookupSupported) {
            var h = this.actualDataProvider.indexOfKey(a);
            return this.actualDataProvider.getItemAtIndex(h);
        }
        if (this.actualDataProvider != null) {
            var i = this.actualDataProvider.actualCount;
            for (var j = 0; j < i; j++) {
                d = this.actualDataProvider.getItemAtIndex(j);
                if (c.i(d, a) == 0) {
                    return d;
                }
            }
        }
        return null;
    };
    LocalDataSource.prototype.getItemPropertyAtIndex = function (a, b) {
        var c;
        if (this.c4 != null) {
            c = this.c4.a6.item(a);
        }
        else {
            c = this.actualDataProvider.getItemAtIndex(a);
        }
        var item_ = c;
        if ((item_ != null && item_.$$isSpecialRow !== undefined)) {
            return this.getSpecialRowItemValue(c, b);
        }
        if (this.ap()) {
            var d = this.am(c, b);
            if (d) {
                var e = this.a0(c, b);
                return e;
            }
        }
        return this.actualDataProvider.getItemValue(c, b);
    };
    LocalDataSource.prototype.cz = function () {
        return this.actualDataProvider;
    };
    LocalDataSource.prototype.c9 = function () {
        return this.dg != null && this.dg.count > 0;
    };
    LocalDataSource.prototype.refreshInternalOverride = function () {
        _super.prototype.refreshInternalOverride.call(this);
        if (this.actualDataProvider != null) {
            if (this.da() || this.db() || this.dc() || this.dd() || this.c9()) {
                if (this.c4 == null) {
                    if (this.c6 == null) {
                        this.c6 = new LocalDataSourceViewUpdateNotifier(this);
                    }
                    this.c4 = new RearrangedListView(this.actualDataProvider);
                    this.c4.ab = this.c6;
                    this.c4.ad = new LocalDataSourceViewExpansionNotifier(this);
                }
                this.ensureComparables(this.actualDataProvider.actualSchema);
                this.c4.av = this.shouldEmitSectionHeaders && this.ao;
                this.c4.au = this.shouldEmitSectionFooters && this.ao;
                this.c4.aw = this.shouldEmitShiftedRows;
                this.c4.cb(this.dg);
                this.c4.a2 = this.df();
                this.c4.a1 = this.de();
                this.c4.p = this.c3();
                this.c4.ae = this.groupDescriptions;
                this.c4.af = this.sortDescriptions;
                this.c4.ag = this.summaryDescriptions;
                this.c4.l = this.summaryScope;
                this.c4.am = this.includeSummaryRowsInSection;
                this.c4.as = this.isSectionSummaryRowsAtBottom;
                this.c4.j = this.sectionHeaderDisplayMode;
                this.c4.m = this;
                this.c4.ap = this.groupDescriptions != null && this.groupDescriptions.k.count > 0;
                this.c4.t = this.c5();
                this.c4.b6();
                this.actualSchema = this.actualDataProvider.actualSchema;
                this.actualCount = this.c4.a6.count;
            }
            else {
                var a = this.cz();
                this.actualSchema = this.actualDataProvider.actualSchema;
                if (a != null) {
                    this.actualCount = a.actualCount;
                }
                else {
                    this.actualCount = 0;
                }
                if (this.c4 != null) {
                    this.c4.ab = null;
                    this.c4 = null;
                    this.onBroadcastClearItems();
                }
            }
        }
        else {
            this.actualCount = 0;
            this.actualSchema = null;
        }
    };
    LocalDataSource.prototype.get_isItemIndexLookupSupported = function () {
        return true;
    };
    LocalDataSource.prototype.get_isKeyIndexLookupSupported = function () {
        return true;
    };
    LocalDataSource.prototype.indexOfItem = function (a) {
        if (this.c4 != null) {
            return this.c4.a6.indexOf(a);
        }
        if (this.actualDataProvider != null && this.actualDataProvider.isItemIndexLookupSupported) {
            return this.actualDataProvider.indexOfItem(a);
        }
        if (this.actualDataProvider != null) {
            var b = this.actualDataProvider.actualCount;
            var c = void 0;
            for (var d = 0; d < b; d++) {
                c = this.actualDataProvider.getItemAtIndex(d);
                if (this.c8(c, a)) {
                    return d;
                }
            }
        }
        return -1;
    };
    LocalDataSource.prototype.c8 = function (a, b) {
        if (a == null && b == null) {
            return true;
        }
        if (a == null || b == null) {
            return false;
        }
        return Base.equalsStatic(a, b);
    };
    LocalDataSource.prototype.indexOfKey = function (a) {
        var b = this.actualPrimaryKey;
        if (b == null || b.length < 1 || this.actualBaseDataProvider == null) {
            return this.indexOfItem(a[0]);
        }
        var c = this.c3();
        var d;
        if (this.c4 != null) {
            var e = this.c4.a6.count;
            for (var f = 0; f < e; f++) {
                d = this.c4.a6.item(f);
                if (typeCast(DataSourceSpecialRow.$, d) !== null) {
                    var g = d;
                    if (g.rowType == 1 && !this.isSectionContentVisible && this.isSectionHeaderNormalRow) {
                        if (c.i(d, a) == 0) {
                            return f;
                        }
                    }
                }
                else if (c.i(d, a) == 0) {
                    return f;
                }
            }
            return -1;
        }
        if (this.actualDataProvider != null && this.actualDataProvider.isKeyIndexLookupSupported) {
            return this.actualDataProvider.indexOfKey(a);
        }
        if (this.actualDataProvider != null) {
            var h = this.actualDataProvider.actualCount;
            for (var i = 0; i < h; i++) {
                d = this.actualDataProvider.getItemAtIndex(i);
                if (c.i(d, a) == 0) {
                    return i;
                }
            }
        }
        return -1;
    };
    LocalDataSource.prototype.onActualPrimaryKeyChangedOverrride = function (a, b) {
        _super.prototype.onActualPrimaryKeyChangedOverrride.call(this, a, b);
        this.c2 = null;
    };
    LocalDataSource.prototype.c3 = function () {
        if (this.c2 != null) {
            return this.c2;
        }
        if (this.actualPrimaryKey == null) {
            this.c2 = new DataSourcePropertiesComparer(null, null, null, this);
            return this.c2;
        }
        var a = new Array(this.actualPrimaryKey.length);
        for (var b = 0; b < a.length; b++) {
            a[b] = 0;
        }
        this.c2 = new DataSourcePropertiesComparer(this.actualPrimaryKey, a, this.d, this);
        return this.c2;
    };
    LocalDataSource.prototype.c5 = function () {
        if (this.filterExpressions.j.count == 0) {
            return null;
        }
        var a = this.actualDataProvider;
        var b = this.actualDataProvider.actualSchema;
        var c = this.filterExpressions.j;
        var d = function (e) {
            for (var f = 0; f < c.count; f++) {
                if (!c.item(f).match(e, a, b)) {
                    return false;
                }
            }
            return true;
        };
        return d;
    };
    LocalDataSource.prototype.df = function () {
        var a = 0;
        if (this.sortDescriptions.k.count == 0 && (this.groupDescriptions == null || this.groupDescriptions.k.count == 0)) {
            return null;
        }
        a = this.sortDescriptions.k.count;
        if (this.groupDescriptions != null) {
            a += this.groupDescriptions.k.count;
        }
        var b = new Array(a);
        var c = new Array(a);
        var d = 0;
        if (this.groupDescriptions != null) {
            for (var e = 0; e < this.groupDescriptions.k.count; e++) {
                b[e] = this.groupDescriptions.k.item(e).propertyName;
                c[e] = this.groupDescriptions.k.item(e).direction;
                d++;
            }
        }
        for (var f = 0; f < this.sortDescriptions.k.count; f++) {
            b[f + d] = this.sortDescriptions.k.item(f).propertyName;
            c[f + d] = this.sortDescriptions.k.item(f).direction;
        }
        return new DataSourcePropertiesComparer(b, c, this.d, this);
    };
    LocalDataSource.prototype.de = function () {
        if (this.groupDescriptions == null || this.groupDescriptions.k.count < 1) {
            return null;
        }
        var a = 0;
        a = this.groupDescriptions.k.count;
        var b = new Array(a);
        var c = new Array(a);
        if (this.groupDescriptions != null) {
            for (var d = 0; d < this.groupDescriptions.k.count; d++) {
                b[d] = this.groupDescriptions.k.item(d).propertyName;
                c[d] = this.groupDescriptions.k.item(d).direction;
            }
        }
        return new DataSourcePropertiesComparer(b, c, this.d, this);
    };
    LocalDataSource.prototype.db = function () {
        if (this.groupDescriptions == null || this.groupDescriptions.k.count < 1) {
            return false;
        }
        if (this.actualDataProvider == null) {
            return false;
        }
        if (this.actualDataProvider.isGroupingSupported) {
            return false;
        }
        return true;
    };
    LocalDataSource.prototype.dc = function () {
        if (this.sortDescriptions == null || this.sortDescriptions.k.count < 1) {
            return false;
        }
        if (this.actualDataProvider == null) {
            return false;
        }
        if (this.actualDataProvider.isSortingSupported) {
            return false;
        }
        return true;
    };
    LocalDataSource.prototype.da = function () {
        return this.filterExpressions != null && this.filterExpressions.j.count > 0;
    };
    LocalDataSource.prototype.dd = function () {
        if (this.summaryDescriptions == null || this.summaryDescriptions.k.count < 1) {
            return false;
        }
        return true;
    };
    LocalDataSource.prototype.onClearItemsOverride = function () {
        if (this.c4 != null) {
            this.c4.notifyClearItems();
            this.queueAutoRefresh();
        }
        else {
            _super.prototype.onClearItemsOverride.call(this);
        }
    };
    LocalDataSource.prototype.onSetItemOverride = function (a, b, c) {
        if (this.c4 != null) {
            this.c4.notifySetItem(a, b, c);
        }
        else {
            _super.prototype.onSetItemOverride.call(this, a, b, c);
        }
    };
    LocalDataSource.prototype.onInsertItemOverride = function (a, b) {
        if (this.c4 != null) {
            this.c4.notifyInsertItem(a, b);
        }
        else {
            _super.prototype.onInsertItemOverride.call(this, a, b);
        }
    };
    LocalDataSource.prototype.onRemoveItemOverride = function (a, b) {
        if (this.c4 != null) {
            this.c4.notifyRemoveItem(a, b);
        }
        else {
            _super.prototype.onRemoveItemOverride.call(this, a, b);
        }
    };
    LocalDataSource.prototype.d0 = function () {
        this.actualCount = this.c4.a6.count;
        this.onBroadcastClearItems();
    };
    LocalDataSource.prototype.d3 = function (a, b, c) {
        this.actualCount = this.c4.a6.count;
        this.onBroadcastSetItem(a, b, c);
    };
    LocalDataSource.prototype.d1 = function (a, b) {
        this.actualCount = this.c4.a6.count;
        this.onBroadcastInsertItem(a, b);
    };
    LocalDataSource.prototype.d2 = function (a, b) {
        this.actualCount = this.c4.a6.count;
        this.onBroadcastRemoveItem(a, b);
    };
    LocalDataSource.prototype.pinRow = function (a) {
        _super.prototype.pinRow.call(this, a);
        this.dp = -1;
        this.dh = -1;
        if (this.c4 != null) {
            this.dg.add(a);
            this.c4.b5(a);
        }
        else {
            this.dg.add(a);
            this.queueAutoRefresh();
        }
    };
    LocalDataSource.prototype.unpinRow = function (a) {
        _super.prototype.unpinRow.call(this, a);
        var b = this.c3();
        if (this.c4 != null) {
            for (var c = this.dg.count - 1; c >= 0; c--) {
                var d = this.dg._inner[c];
                if (d.length != a.length) {
                    continue;
                }
                if (b.h(d, a) == 0) {
                    this.dg.removeAt(c);
                    this.c4.cc(d);
                }
            }
        }
        else {
            for (var e = this.dg.count - 1; e >= 0; e--) {
                var f = this.dg._inner[e];
                if (f.length != a.length) {
                    continue;
                }
                if (b.h(f, a) == 0) {
                    this.dg.removeAt(e);
                }
            }
            this.queueAutoRefresh();
        }
        this.dp = -1;
        this.dh = -1;
    };
    LocalDataSource.prototype.clearPinnedRows = function () {
        for (var a = this.dg.count - 1; a >= 0; a--) {
            this.unpinRow(this.dg._inner[a]);
        }
    };
    LocalDataSource.prototype.isRowPinned = function (a) {
        if (this.c4 == null) {
            return false;
        }
        var b = this.getItemAtIndex(a);
        if (b == null) {
            return false;
        }
        var item_ = b;
        if ((item_ != null && item_.$$isSpecialRow !== undefined)) {
            if (item_.rowType == 3) {
                return true;
            }
        }
        var c = this.c3();
        var d;
        if (this.actualPrimaryKey == null) {
            d = new Array(1);
            d[0] = b;
        }
        else {
            var e = this.actualPrimaryKey;
            var f = e.length;
            d = new Array(f);
            for (var g = 0; g < f; g++) {
                d[g] = this.getItemProperty(b, e[g]);
            }
        }
        for (var h = 0; h < this.dg.count; h++) {
            if (c.h(this.dg._inner[h], d) == 0) {
                return true;
            }
        }
        return false;
    };
    LocalDataSource.prototype.get_isSortingSupported = function () {
        if (this.externalDataSource != null && !this.c7) {
            this.c7 = true;
            var a = this.externalDataSource.isSortingSupportedOverride;
            this.c7 = false;
            return a;
        }
        return true;
    };
    LocalDataSource.prototype.get_isFilteringSupported = function () {
        if (this.externalDataSource != null && !this.c7) {
            this.c7 = true;
            var a = this.externalDataSource.isFilteringSupportedOverride;
            this.c7 = false;
            return a;
        }
        return true;
    };
    LocalDataSource.prototype.get_isGroupingSupported = function () {
        if (this.externalDataSource != null && !this.c7) {
            this.c7 = true;
            var a = this.externalDataSource.isGroupingSupportedOverride;
            this.c7 = false;
            return a;
        }
        return true;
    };
    LocalDataSource.prototype.getStickyRowPriority = function (a) {
        var b = this.getRowType(a);
        switch (b) {
            case 1: return 100 - this.getRowLevel(a);
            case 2: return 99 - this.getRowLevel(a);
            case 3:
            case 5: return 2;
            case 4: return 3;
        }
        return 1;
    };
    LocalDataSource.prototype.getStickyRowsInRange = function (a, b) {
        if (this.c4 == null || ((this.groupDescriptions == null || this.groupDescriptions.k.count == 0) && (this.summaryDescriptions == null || this.summaryDescriptions.k.count == 0) && !this.c9())) {
            return null;
        }
        var c = null;
        var d = null;
        if (this.c4.a5.count == 1) {
            c = this.c4.a5._inner[0];
            d = this.c4.a5._inner[0];
        }
        else {
            c = this.c4.w(a);
            if (c != null) {
                while (c.z != -1) {
                    c = this.c4.a5._inner[c.z];
                }
            }
            d = this.c4.w(b);
            if (b >= this.c4.a6.count - this.c4.bk) {
                d = this.c4.v();
            }
        }
        if (c == null || d == null) {
            return null;
        }
        if (c.ae == this.dp && c.aa == this.dr && c.af == this.ds && c.ad == this.dq && c.ah == this.du && c.ag == this.dt && d.ae == this.dh && d.aa == this.dj && d.af == this.dk && d.ad == this.di && d.ah == this.dm && d.ag == this.dl && this.c4.bk == this.dn) {
            return this.ct;
        }
        this.dp = c.ae;
        this.dh = d.ae;
        this.dr = c.aa;
        this.dj = d.aa;
        this.ds = c.af;
        this.dk = d.af;
        this.dq = c.ad;
        this.di = d.ad;
        this.du = c.ah;
        this.dt = c.ag;
        this.dm = d.ah;
        this.dl = d.ag;
        this.dn = this.c4.bk;
        if (this.c4.a5.count == 1) {
            this.dh = d.ad;
        }
        var e = 0;
        if (this.shouldEmitSectionHeaders && this.ao) {
            e = 1;
        }
        var f = this.c4.ba();
        var g = new List$1(Number_$type, 0);
        for (var h = c.ae; h <= d.ae; h++) {
            var i = this.c4.a5._inner[h];
            var j = this.c4.a5._inner[h].c.length;
            var k = this.c4.a5._inner[h].v();
            if (this.shouldEmitSectionHeaders && this.ao) {
                for (var l = 0; l < j; l++) {
                    if (this.c4.a5._inner[h].a[l] != null) {
                        var m = i.af + i.b[l];
                        g.add(m);
                        if (this.summaryScope == 0 || this.summaryScope == 2) {
                            if (i.c[l] && this.includeSummaryRowsInSection && !this.isSectionSummaryRowsAtBottom) {
                                for (var n = 0; n < f; n++) {
                                    g.add(m + 1 + n);
                                }
                            }
                        }
                    }
                    if (!this.c4.a5._inner[h].c[l]) {
                        break;
                    }
                }
            }
            if (this.c4.a5._inner[h].p) {
                if (this.shouldEmitShiftedRows) {
                    for (var o = 0; o < this.c4.a5._inner[h].aa; o++) {
                        g.add(this.c4.a5._inner[h].af + this.c4.a5._inner[h].ah + o + k);
                    }
                }
            }
            if (this.summaryScope == 0 || this.summaryScope == 2) {
                if (this.includeSummaryRowsInSection && this.isSectionSummaryRowsAtBottom) {
                    for (var p = this.c4.a5._inner[h].ag - 1; p >= 0; p--) {
                        if (this.shouldEmitSectionFooters) {
                            g.add(this.c4.a5._inner[h].ad - k - p);
                        }
                        else {
                            g.add(this.c4.a5._inner[h].ad - p);
                        }
                    }
                }
            }
            if (this.shouldEmitSectionFooters && this.ao) {
                for (var q = j - 1; q >= 0; q--) {
                    if (!this.c4.a5._inner[h].c[q]) {
                        break;
                    }
                    g.add(this.c4.a5._inner[h].ad - q);
                }
            }
        }
        for (var r = this.c4.a6.count - this.c4.bk; r < this.c4.a6.count; r++) {
            g.add(r);
        }
        this.ct = g.toArray();
        return this.ct;
    };
    LocalDataSource.prototype.isExclusivelySticky = function (a) {
        var b = this.getRowType(a);
        return b == 1 || b == 2 || b == 4 || (this.isSectionSummaryRowsAtBottom && b == 5);
    };
    LocalDataSource.prototype.getRowType = function (a) {
        if (a < 0) {
            return 0;
        }
        var b = this.getItemAtIndex(a);
        var item_ = b;
        if ((item_ != null && item_.$$isSpecialRow !== undefined)) {
            var c = b.rowType;
            if (this.isSectionHeaderNormalRow && c == 1) {
                return 0;
            }
            return c;
        }
        return 0;
    };
    LocalDataSource.prototype.setIsRowExpandedAtIndex = function (a, b) {
        if (this.isSectionCollapsable && this.c4 != null && this.c4.a6.count > 0 && this.c4.a6.count > a) {
            this.c4.ca(a, b);
        }
    };
    LocalDataSource.prototype.getIsRowExpandedAtIndex = function (a) {
        if (this.c4 != null && this.c4.a6.count > 0 && this.c4.a6.count > a) {
            return this.c4.ak(a);
        }
        return true;
    };
    LocalDataSource.prototype.getRowLevel = function (a) {
        if (a < 0) {
            return 0;
        }
        var b = this.getItemAtIndex(a);
        var item_ = b;
        if ((item_ != null && item_.$$isSpecialRow !== undefined)) {
            return b.level;
        }
        if (this.sectionHeaderDisplayMode == 1) {
            return this.groupDescriptions.k.count;
        }
        else if (this.groupDescriptions.k.count > 0) {
            return 1;
        }
        return 0;
    };
    LocalDataSource.prototype.getRootSummaryRowCount = function () {
        if (this.c4 != null) {
            return this.c4.bk;
        }
        return 0;
    };
    LocalDataSource.prototype.getRootSummaryResults = function () {
        if (this.c4 != null) {
            return this.c4.i;
        }
        return null;
    };
    LocalDataSource.prototype.getSectionSummaryResults = function (a) {
        if (this.c4 != null && this.c4.a5.count > 0 && a >= 0 && a < this.c4.a5.count) {
            return this.c4.a5._inner[a].i;
        }
        return null;
    };
    LocalDataSource.prototype.clone = function () {
        var a = new LocalDataSource();
        a.dataSource = this.dataSource;
        _super.prototype.cloneProperties.call(this, a);
        return a;
    };
    LocalDataSource.prototype.ap = function () {
        return !this.isReadOnly && this.actualBaseDataProvider != null && this.u != null;
    };
    LocalDataSource.prototype.cm = function (a, b) {
        var e_1, _a, e_2, _b;
        if (a == 5) {
            var c = new List$1(TransactionType_$type, 0);
            var d = new List$1(Base.$, 0);
            var e = b;
            var f = e.a;
            for (var g = 0; g < f.length; g++) {
                if (f[g].transactionType == 1) {
                    var h = f[g].id;
                    var i = this.getItemFromKey(h);
                    if (i != null) {
                        var j = f[g].value;
                        var k = this.indexOfItem(i);
                        var l = null;
                        if (this.c4 != null && k > -1) {
                            l = this.c4.w(k);
                            for (var m = 0; m < this.summaryDescriptions.k.count; m++) {
                                var n = this.summaryDescriptions.k.item(m);
                                if (n.operand == 5 || j.containsKey(n.propertyName)) {
                                    this.c4.cl(m, k, i, false, l);
                                }
                            }
                        }
                        try {
                            for (var _c = (e_1 = void 0, tslib_1.__values(fromEnum(j))), _d = _c.next(); !_d.done; _d = _c.next()) {
                                var o = _d.value;
                                this.actualDataProvider.setItemValue(i, o.key, o.value);
                            }
                        }
                        catch (e_1_1) {
                            e_1 = { error: e_1_1 };
                        }
                        finally {
                            try {
                                if (_d && !_d.done && (_a = _c.return))
                                    _a.call(_c);
                            }
                            finally {
                                if (e_1)
                                    throw e_1.error;
                            }
                        }
                        if (l != null && this.c4 != null && k > -1) {
                            for (var p = 0; p < this.summaryDescriptions.k.count; p++) {
                                var q = this.summaryDescriptions.k.item(p);
                                if (q.operand == 5 || j.containsKey(q.propertyName)) {
                                    this.c4.cl(p, k, i, true, l);
                                }
                            }
                        }
                        if (k > -1) {
                            this.onBroadcastSetItem(k, i, i);
                        }
                        d.add1(i);
                        c.add(1);
                        if (this.dg.count > 0) {
                            var r = this.c3();
                            for (var s = 0; s < this.dg.count; s++) {
                                if (r.h(this.dg._inner[s], h) == 0) {
                                    var t = this.getStickyRows();
                                    for (var u = 0; u < t.length; u++) {
                                        var v = t[u];
                                        var w = typeCast(DataSourceSpecialRow.$, this.c4.a6.item(v));
                                        if (w != null && w.rowType == 3 && w.targetRow == i) {
                                            this.onBroadcastSetItem(v, w, w);
                                            break;
                                        }
                                    }
                                    break;
                                }
                            }
                        }
                    }
                }
                else if (f[g].transactionType == TransactionType.Delete) {
                    var x = f[g].id;
                    var y = this.indexOfKey(x);
                    if (y > -1) {
                        var z = this.getItemAtIndex(y);
                        this.actualDataProvider.removeItem(z);
                        this.notifyRemoveItem(y, z);
                        d.add1(z);
                        c.add(TransactionType.Delete);
                    }
                }
                else if (f[g].transactionType == 0) {
                    var aa = f[g].id[0];
                    if (f[g].value != null) {
                        var ab = f[g].value;
                        try {
                            for (var _e = (e_2 = void 0, tslib_1.__values(fromEnum(ab))), _f = _e.next(); !_f.done; _f = _e.next()) {
                                var ac = _f.value;
                                this.actualDataProvider.setItemValue(aa, ac.key, ac.value);
                            }
                        }
                        catch (e_2_1) {
                            e_2 = { error: e_2_1 };
                        }
                        finally {
                            try {
                                if (_f && !_f.done && (_b = _e.return))
                                    _b.call(_e);
                            }
                            finally {
                                if (e_2)
                                    throw e_2.error;
                            }
                        }
                    }
                    this.actualDataProvider.addItem(aa);
                    d.add1(aa);
                    c.add(0);
                }
            }
            if (f.length > 0) {
                this.by(e.id, this.getAggregatedChanges(e.id));
            }
        }
    };
    LocalDataSource.$t = markType(LocalDataSource, 'LocalDataSource', BaseDataSource.$);
    return LocalDataSource;
}(BaseDataSource));
export { LocalDataSource };
/**
 * @hidden
 */
var LocalDataSourceViewUpdateNotifier = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(LocalDataSourceViewUpdateNotifier, _super);
    function LocalDataSourceViewUpdateNotifier(a) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.a = a;
        return _this;
    }
    LocalDataSourceViewUpdateNotifier.prototype.notifyClearItems = function () {
        this.a.d0();
    };
    LocalDataSourceViewUpdateNotifier.prototype.notifyInsertItem = function (a, b) {
        this.a.d1(a, b);
    };
    LocalDataSourceViewUpdateNotifier.prototype.notifyRemoveItem = function (a, b) {
        this.a.d2(a, b);
    };
    LocalDataSourceViewUpdateNotifier.prototype.notifySetItem = function (a, b, c) {
        this.a.d3(a, b, c);
    };
    LocalDataSourceViewUpdateNotifier.$t = markType(LocalDataSourceViewUpdateNotifier, 'LocalDataSourceViewUpdateNotifier', Base.$, [ISupportsDataChangeNotifications_$type]);
    return LocalDataSourceViewUpdateNotifier;
}(Base));
export { LocalDataSourceViewUpdateNotifier };
/**
 * @hidden
 */
var LocalDataSourceViewExpansionNotifier = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(LocalDataSourceViewExpansionNotifier, _super);
    function LocalDataSourceViewExpansionNotifier(a) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.a = a;
        return _this;
    }
    LocalDataSourceViewExpansionNotifier.prototype.notifyRowExpansionChanged = function (a, b, c) {
        this.a.onRowExpansionChanged(a, b, c);
    };
    LocalDataSourceViewExpansionNotifier.$t = markType(LocalDataSourceViewExpansionNotifier, 'LocalDataSourceViewExpansionNotifier', Base.$, [ISupportsExpansionChangeNotifications_$type]);
    return LocalDataSourceViewExpansionNotifier;
}(Base));
export { LocalDataSourceViewExpansionNotifier };
//# sourceMappingURL=LocalDataSource_combined.js.map
